

































































































































import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, Mutation, State } from "vuex-class";

import { validationMixin } from "vuelidate";
import {
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";

import { falconComplaintPositiveDecisionFilter } from "@/filters/falcon/falcon-complaint-positive-decision.filter";
import { falconComplaintNegativeDecisionFilter } from "@/filters/falcon/falcon-complaint-negative-decision.filter";
import { falconComplaintFaultEntityFilter } from "@/filters/falcon/falcon-complaint-fault-entity.filter";
import { falconComplaintFaultMomentFilter } from "@/filters/falcon/falcon-complaint-fault-moment.filter";
import { capitalizeFilter } from "@/filters/capitalize.filter";
import { booleanTextFilter } from "@/filters/boolean-text.filter";

import { maxCurrentDateValidator } from "@/validators/max-current-date.validator";

import { GetComplaintQuantityAvailableFalconRequest } from "@/interfaces/falcon/get-complaint-quantity-available/get-complaint-quantity-available-falcon-request";
import { DoCreateComplaintFirstStepFormData } from "@/interfaces/falcon/do-create-complaint/do-create-complaint-first-step-form-data";

import { FalconComplaintPositiveDecision } from "@/enums/falcon/complaints/falcon-complaint-positive-decision.enum";
import { FalconComplaintNegativeDecision } from "@/enums/falcon/complaints/falcon-complaint-negative-decision.enum";
import { FalconComplaintFaultEntity } from "@/enums/falcon/complaints/falcon-complaint-fault-entity.enum";
import { FalconComplaintFaultMoment } from "@/enums/falcon/complaints/falcon-complaint-fault-moment.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint creation first step form - details
 */
@Component<ComplaintCreationFirstStepForm>({
  mixins: [validationMixin],
  filters: {
    ...falconComplaintPositiveDecisionFilter,
    ...falconComplaintNegativeDecisionFilter,
    ...falconComplaintFaultEntityFilter,
    ...falconComplaintFaultMomentFilter,
    ...capitalizeFilter,
    ...booleanTextFilter
  },
  validations() {
    return {
      form: {
        dateProductDelivery: {
          maxDate: maxCurrentDateValidator()
        },
        quantity: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(this.complaintQuantityAvailable)
        },
        decisionIfYes: { required },
        decisionIfNo: { required },
        refuseAddCosts: {},
        compensationValue: {},
        compensationCurrency: {}
      }
    };
  }
})
export default class ComplaintCreationFirstStepForm extends Vue {
  @Mutation("falconComplaints/firstStepFormUpdated")
  private firstStepFormUpdated!: (
    formData: DoCreateComplaintFirstStepFormData
  ) => void;
  @Action("falconComplaints/getComplaintQuantityAvailable")
  private getComplaintQuantityAvailable!: (
    request: GetComplaintQuantityAvailableFalconRequest
  ) => void;
  @Watch("$route", { immediate: true }) private routeUpdated(): void {
    const { documentId, itemId, productId } = this.$route.params;
    this.documentId = documentId;
    this.getComplaintQuantityAvailable({
      getComplaintQuantityAvailable: {
        complaintInfo: {
          srcDocumentId: documentId,
          srcItemId: itemId,
          productId
        }
      }
    });
  }
  @State(state => state.falconComplaints.complaintFormData.details)
  private detailsFormData!: DoCreateComplaintFirstStepFormData;

  private documentId = "";

  @State(state => state.falconComplaints.complaintQuantityAvailable)
  complaintQuantityAvailable!: number;

  falconPositiveDecisionEnum = FalconComplaintPositiveDecision;
  falconNegativeDecisionEnum = FalconComplaintNegativeDecision;
  falconComplaintEntityEnum = FalconComplaintFaultEntity;
  falconFaultMomentEnum = FalconComplaintFaultMoment;
  i18nMessageKeyEnum = I18nMessageKey;

  form: DoCreateComplaintFirstStepFormData = {
    dateProductDelivery: "",
    serialNumber: "",
    quantity: 1,
    decisionIfYes: FalconComplaintPositiveDecision.Refund,
    decisionIfNo: FalconComplaintNegativeDecision.Scrapping,
    faultFoundBy: FalconComplaintFaultEntity.Workshop,
    faultWhen: FalconComplaintFaultMoment.BeforeAssembly,
    refuseAddCosts: 1,
    compensationValue: undefined,
    compensationCurrency: undefined
  };

  get nextStepUrl(): string {
    let url = "vehicle";
    if (
      this.detailsFormData.faultWhen ===
      FalconComplaintFaultMoment.BeforeAssembly
    ) {
      url = "fault-description";
    }
    return url;
  }

  created(): void {
    this.form = { ...this.detailsFormData };
  }

  formDataChanged(): void {
    this.firstStepFormUpdated(this.form);
  }

  get returnUrl(): string {
    return `/app/falcon/documents/${this.documentId}/details`;
  }
}
